/** Global namespace for the `data-src` attribute. */
const dataSRC = "data-src";
export default dataSRC;
